export enum Language {
  ENGLISH = "en-US",
  FRENCH = "fr-CA",
  SPANISH = "es-ES",
}
